import { all, call, put, takeEvery, select } from 'redux-saga/effects'
import axios from 'axios'
import * as Sentry from 'Services/sentry'
import { getTutorialsInfoV2 } from 'Services/api/tutorials'
import { TUTORIAL_STATUS, TUTORIAL_NAMES } from 'Config/constants'

import { CHECK_TUTORIAL_BANNER_V2 } from './types'
import { showRequestTutorialBannerV2, showApproverTutorialBannerV2 } from './actions'

function* checkTutorialV2() {
  try {
    const features = yield select(state => state.auth.config)
    if (!features.tutorial) {
      return
    }
    const tutorialInfo = yield call(getTutorialsInfoV2)

    const requestTutorialDone = tutorialInfo?.find(
      element => element.name === TUTORIAL_NAMES.requestV2 && element.done === TUTORIAL_STATUS.done
    )
    const approverTutorialDone = tutorialInfo?.find(
      element => element.name === TUTORIAL_NAMES.approverRoleV2 && element.done === TUTORIAL_STATUS.done
    )

    if (requestTutorialDone) {
      sessionStorage.removeItem('requestTutorialV2')
    } else {
      sessionStorage.setItem('requestTutorialV2', 'true')
    }

    if (approverTutorialDone) {
      sessionStorage.removeItem('approverTutorialV2')
    } else {
      sessionStorage.setItem('approverTutorialV2', 'true')
    }

    yield put(showRequestTutorialBannerV2(!requestTutorialDone))
    yield put(showApproverTutorialBannerV2(!approverTutorialDone))
  } catch (error) {
    if (!axios.isCancel(error)) {
      Sentry.captureException(error)
    }
    sessionStorage.removeItem('requestTutorialV2')
    sessionStorage.removeItem('approverTutorialV2')
  }
}

function* watchCheckTutorialV2Saga() {
  yield takeEvery(CHECK_TUTORIAL_BANNER_V2, checkTutorialV2)
}

export default function* rootTutorialSaga() {
  yield all(watchCheckTutorialV2Saga())
}
